import styled from "styled-components"

import { spacing } from "@minuthq/meatball-ui-react"

import { ParadiseDetailsHeading } from "src/components/Paradise/ParadiseDetailsHeading"
import { TWarehouse } from "src/data/ecommerce/ecommerceTypes"
import { prettifyApiFieldValue } from "src/data/orders/orderUtils"

export function ParadiseWarehouseMeta({
  warehouse,
}: {
  warehouse: TWarehouse
}) {
  return (
    <div>
      <TitleWrapper>
        <ParadiseDetailsHeading>
          {prettifyApiFieldValue(warehouse.name)}
        </ParadiseDetailsHeading>
      </TitleWrapper>
    </div>
  )
}

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.S};
`
